module.exports = __webpack_public_path__ + "static/media/ui_ux_design.67a6a11c.svg";